module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/icon-grid/icon-grid.component.scss
// module id = ./src/app/modules/common-module/components/icon-grid/icon-grid.component.scss
// module chunks = 9